import * as React from 'react';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';

import css from './loader.css';


export const Loader = ({testId}: {testId?: string}) => {
  return <CircularLoader className={css.loader} testId={testId} />;
};
